"use strict";

exports.__esModule = true;
exports.base = void 0;

var _base = require("./base");

exports.base = _base.base;